export const MAILTO_HREF = "mailto:hudson@getdentalvisuals.com?cc=kevin@getdentalvisuals.com&subject=GetDentalVisuals";